import React from 'react';
import SpeechReport from './SpeechReport';

export default function AnalysisReport({ result, onReset }) {
  const { transcript, language, metrics } = result;
  const { word_count, duration_seconds, wpm, pace_consistency } = metrics;

  const avgWpm = pace_consistency?.avg_wpm ?? wpm ?? 0;
  const formatDuration = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m > 0 ? `${m}m ${sec}s` : `${sec}s`;
  };
  const languageLabel = language
    ? language.split('-').join(' / ').toUpperCase()
    : 'Unknown';

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-display text-2xl font-semibold" style={{ color: 'var(--text-primary)' }}>
            Your Analysis
          </h2>
          <p className="font-mono text-[10px] mt-1 uppercase tracking-[0.15em]"
             style={{ color: 'var(--text-faint)' }}>
            {languageLabel} · {avgWpm} WPM · {word_count?.toLocaleString()} words · {formatDuration(duration_seconds)}
          </p>
        </div>
        <button onClick={onReset} className="btn-bouncy text-sm px-4 py-2">
          Analyze Again
        </button>
      </div>

      <SpeechReport metrics={metrics} transcript={transcript} showTranscript />
    </div>
  );
}
